module.exports = __webpack_public_path__ + "static/media/OffHand_3.1d809733.jpg";